import React from "react";

export const CircleTickGreenFill = () => {
    return (
        <>
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.1944 17.8959C15.0123 17.8959 18.9571 14.158 18.9571 9.49972C18.9571 4.84149 15.0123 1.10352 10.1944 1.10352C5.37647 1.10352 1.43164 4.84149 1.43164 9.49972C1.43164 14.158 5.37647 17.8959 10.1944 17.8959Z" fill="#35F29A" stroke="white" />
                <path d="M8.61036 11.0477L6.68305 9.22754L5.85547 10.0091L8.61036 12.6108L14.2916 7.24543L13.4641 6.46387L8.61036 11.0477Z" fill="white" />
            </svg>
        </>
    )
}